import axios from '@axios'
import api from 'axios'

export default {
  listagemRelatorios(id) {
    return axios.get(`/relatorio/registro/${id}`)
  },
  getReport() {
    return axios.get('/relatorio/')
  },
  printReport(report) {
    return axios.post('relatorio/', report)
  },
  listagemGeral(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort
      },${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `nome_amigavel?nome=${queryFilter.filter}&modulo=${queryFilter.module
        }&page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort
        },${queryFilter.order}`
      return axios.get(`/relatorio/${queryUrl}`)
    }
    return axios.get(`/relatorio/geral/${queryFilter.module}?${queryUrl}`)
  },
  async printReportReceita(report) {
    try {
      const response = await api.post(
        process.env.VUE_APP_URL_API_REPORT,
        {
          template: 'receita.html',
          dados: {
            paciente_procedimento_id: report.paciente_procedimento_id,
          },
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': process.env.VUE_APP_API_KEY_REPORT, // precisa ser pega do .env
          },
          responseType: 'blob',
        },
      )

      const fileURL = URL.createObjectURL(
        new Blob([response.data], { type: 'application/pdf' }),
      )
      window.open(fileURL, '_blank')
      return { msg: 'PDF gerado com sucesso' }
    } catch (err) {
      console.error('Erro ao gerar PDF:', err)
      return { error: 'Erro ao gerar PDF' }
    }
  },

  async printReportExame(report) {
    try {
      const response = await api.post(
        process.env.VUE_APP_URL_API_REPORT,
        {
          template: 'solicitacao_exame.html',
          dados: {
            ...report
          },
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': process.env.VUE_APP_API_KEY_REPORT,
          },
          responseType: 'blob',
        },
      )

      const fileURL = URL.createObjectURL(
        new Blob([response.data], { type: 'application/pdf' }),
      )
      window.open(fileURL, '_blank')
      return { msg: 'PDF gerado com sucesso' }
    } catch (err) {
      console.error('Erro ao gerar PDF de Exame:', err)
      return { error: 'Erro ao gerar PDF de Exame' }
    }
  },

  async printReportDre(report) {
    try {
      const response = await api.post(
        process.env.VUE_APP_URL_API_REPORT,
        {
          template: 'dre_report.html',
          dados: report,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': process.env.VUE_APP_API_KEY_REPORT,
          },
          responseType: 'blob',
        },
      )

      const fileURL = URL.createObjectURL(
        new Blob([response.data], { type: 'application/pdf' }),
      )
      window.open(fileURL, '_blank')
      return { msg: 'PDF gerado com sucesso' }
    } catch (err) {
      console.error('Erro ao gerar PDF do DRE:', err)
      return { error: 'Falha ao gerar o PDF da DRE. Tente novamente mais tarde.' }
    }
  },

  async printReportRazaoLivro(report) {
    try {
      const response = await api.post(
        process.env.VUE_APP_URL_API_REPORT,
        { template: 'razao_livro.html', dados: report },
        { headers: { 'Content-Type': 'application/json', 'X-API-KEY': process.env.VUE_APP_API_KEY_REPORT }, responseType: 'blob' }
      )
      const fileURL = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
      window.open(fileURL, '_blank')
      return { msg: 'PDF gerado com sucesso' }
    } catch (err) { return { error: 'Falha ao gerar o PDF do Livro Razão.' } }
  },

  async printReportRazaoAnalitico(report) {
    try {
      const response = await api.post(
        process.env.VUE_APP_URL_API_REPORT,
        { template: 'razao_analitico.html', dados: report },
        { headers: { 'Content-Type': 'application/json', 'X-API-KEY': process.env.VUE_APP_API_KEY_REPORT }, responseType: 'blob' }
      )
      const fileURL = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
      window.open(fileURL, '_blank')
      return { msg: 'PDF gerado com sucesso' }
    } catch (err) { return { error: 'Falha ao gerar o PDF do Razão Analítico.' } }
  },

  async printReportRazaoHierarquico(report) {
    try {
      const response = await api.post(
        process.env.VUE_APP_URL_API_REPORT,
        { template: 'razao_hierarquico.html', dados: report },
        { headers: { 'Content-Type': 'application/json', 'X-API-KEY': process.env.VUE_APP_API_KEY_REPORT }, responseType: 'blob' }
      )
      const fileURL = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
      window.open(fileURL, '_blank')
      return { msg: 'PDF gerado com sucesso' }
    } catch (err) { return { error: 'Falha ao gerar o PDF do Razão Hierárquico.' } }
  },

  async generateExcelReport(report) {
    try {
      const response = await api.post(
        `${process.env.VUE_APP_URL_API_REPORT}-xlsx`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': process.env.VUE_APP_API_KEY_REPORT,
          },
          responseType: 'blob',
        },
      )

      // Criar um link para download do arquivo Excel
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `relatorio_${report.nome || 'associados'}.xlsx`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)

      return { msg: 'Relatório Excel gerado com sucesso' }
    } catch (err) {
      console.error('Erro ao gerar relatório Excel:', err)
      return { error: 'Erro ao gerar relatório Excel' }
    }
  },

  async printReportEmprestimo(report) {
    try {
      console.log('Enviando requisição para relatório de empréstimo:', {
        template: 'relatorio-emprestimo.html',
        dados: {
          parcelamento_id: report.id,
        },
      })

      const response = await api.post(
        process.env.VUE_APP_URL_API_REPORT,
        {
          template: 'relatorio-emprestimo.html',
          dados: {
            parcelamento_id: report.id,
          },
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': process.env.VUE_APP_API_KEY_REPORT,
          },
          responseType: 'blob',
        },
      )

      const fileURL = URL.createObjectURL(
        new Blob([response.data], { type: 'application/pdf' }),
      )
      window.open(fileURL, '_blank')
      return { msg: 'Relatório de Empréstimo gerado com sucesso' }
    } catch (err) {
      console.error('Erro ao gerar relatório de empréstimo:', err)
      console.error('Detalhes do erro:', err.response?.data)
      return { error: 'Erro ao gerar relatório de empréstimo' }
    }
  },

  async printReportAmortizacao(report) {
    try {
      console.log('Enviando requisição para relatório de amortização:', {
        template: 'relatorio-amortizacao.html',
        dados: {
          parcelamento_id: report.id,
        },
      })

      const response = await api.post(
        process.env.VUE_APP_URL_API_REPORT,
        {
          template: 'relatorio-amortizacao.html',
          dados: {
            parcelamento_id: report.id,
          },
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': process.env.VUE_APP_API_KEY_REPORT,
          },
          responseType: 'blob',
        },
      )

      const fileURL = URL.createObjectURL(
        new Blob([response.data], { type: 'application/pdf' }),
      )
      window.open(fileURL, '_blank')
      return { msg: 'Relatório de Amortização gerado com sucesso' }
    } catch (err) {
      console.error('Erro ao gerar relatório de amortização:', err)
      console.error('Detalhes do erro:', err.response?.data)
      return { error: 'Erro ao gerar relatório de amortização' }
    }
  },
}
